<template>
  <div class="race-question">
    <modal name="addPromoCode" @before-close="onClose" class="addPromoCode" :adaptive="true" :scrollable="true" height="auto" width="80%" maxWidth="500">
      <div style="padding: 20px;">
        <h3>Add Promo Code</h3>
        <div class="errorMsg" v-if="invalidError">{{invalidMsg}}</div>
      <div class="form-data-outer">
        <div class="form-data">
          <label>Promo Code</label>
          <input v-model="promoCodeData.code"  @change="changeHandle">          
        </div>
         <div class="form-data">
          <label>Total Times Used </label>
          <input v-model="promoCodeData.totalTimesUsed" @change="changeHandle">         
        </div>
        <div class="form-data">
          <label>Usage Limit </label>
          <input v-model="promoCodeData.usageLimit" @change="changeHandle">         
        </div>
        <div class="form-data">
          <label>ExpirationDate</label>  

           <date-time-field v-model="promoCodeData.expirationDate" name="date"
             data-vv-value-path="startDate.time" data-vv-name="date" ></date-time-field>
        </div>

        <div class="form-data my-tag-field">
          <label>Tag</label>
          <selectize v-bind:options="tagsOptions" v-model="selectedTags" multiple size="1" 
            data-dropdown-parent="body" data-max-options="100" :isRunnerTag='false' :isRaceTag='false'
            data-value-field= 'id' data-label-field='name' data-search-field= 'name' data-sort-field= 'name'
            style="visibility:hidden">
          </selectize>
        </div>

      <div class="saveBtn">
        <button class="btn btn--primary" v-on:click="Save()" style="float:none">Save</button>
      </div>

        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import Vue from "vue"
import DateField from '@/components/Forms/DateField'
import DateTimeField from '@/components/Forms/DateTimeField'
import PromoCodeService from "../../../../services/promoCode"
import Selectize from '@/components/Selectize'
import TagService from '../../../../services/tag'

export default {
  name: "add-promo-code",
  data: () => ({
   promoCodeData:{
      "code": "",
      "totalTimesUsed": 0,
      "usageLimit": "",
      "expirationDate": '',
      "tags": null,   
    },
    tagsOptions:[],
    selectedTags:[],
    invalidError:false,
    invalidMsg:''
  }),
  props: {
    show: false
  },
  methods: {
    changeHandle(){
      this.invalidError=false
      this.invalidMsg=""
    },
    onClose() {
      //EventBus.$emit('date','true')
      this.promoCodeData={
        "code": "",
        "totalTimesUsed": 0,
        "usageLimit": '',
        "expirationDate": '',
        "tags": null,   
      }
      this.selectedTags=[]
      this.$emit("closed", true)
    },
    openAddModal() {
      this.getAllTags()
      this.showError(false,"")
      this.$modal.show('addPromoCode')
    },
    showError(error,msg){
      this.invalidError=error
      this.invalidMsg=msg
    },
    Save() {    
        var tagList =[]
        this.selectedTags.forEach(tag => {
         // tagList.push({'id':parseInt(tag)})
          tagList.push(this.tagsOptions.find((e)=>e.id == parseInt(tag)))
        })
        this.promoCodeData.tags= tagList
        var that = this
        if(this.promoCodeData.code == ''){
           that.showError(true,"Please enter Promo Code")
           return
        }
        PromoCodeService.create(this.promoCodeData).then(response => {
          //console.log("response---",response)
              //this.$emit('saved', response.data)
              that.showError(false,"")
              that.$emit('saved')
              that.$modal.hide('addPromoCode')            
            }).catch(error => {
              console.log("err---",error)
              that.showError(true,error.data.description)
              //this.$refs.addLuckyRunner.close()
            }) 
     
               
    },
    getAllTags(){
      TagService.getAllTags().then((response)=>{
        //console.log("response----",response)
        this.tagsOptions = response.data    
      })
    },
  },
  created() {
    //this.getAllTags()
    //this.$watch("show", function(val) {})
  },

  watch: {
    show(oldVal, newVal) {
      if (this.show) {
        this.openAddModal()
      }
    }
  },
  components: {
    DateField,
    DateTimeField,
    Selectize
  }
}
</script>
<style>
.addPromoCode .sweet-title {
    text-align: center;
    color: #423799;
}
.addPromoCode .sweet-modal {
  border-radius: 30px;
  border: 2px solid #ccc;
}
/* .addLuckyRunner .sweet-content-content label {
    width: 100%;
    display: inline-block;
    margin-bottom:20px;
} */
.addPromoCode .sweet-content-content input {
    width: 65%;
    border-radius: 15px;
    border: 1px solid #ccc;
    padding: 0px 15px;
    height: 40px;
    font-size: 17px;
    min-width: 165px;
}
.addPromoCode .form-data-outer {
    padding: 0px 20px 0 20px;
}
.addPromoCode .sweet-content-content textarea {
    width: 65%;
    border-radius: 15px;
    border: 1px solid #ccc;
    padding: 12px 15px;
    min-height:90px;
}
.addPromoCode .errorMsg {
  padding: 10px;
  color: red;
  text-align: center;
}
.addPromoCode .sweet-modal.is-alert .sweet-content{padding:0 5px;}
.addPromoCode .sweet-content-content label {     
    float: left;
    width: 30%;
    margin-top: 11px;
    font-size: 18px;
    margin-right: 10px;
    color: #3e3c3c;
}
.addPromoCode .saveBtn{
  text-align: center;
  margin-top:40px;
}
.addPromoCode .form-data {
    margin-bottom: 20px;
}
.my-tag-field .selectize-input{
  width:65%
}
</style>



// WEBPACK FOOTER //
// AddPromoCode.vue?53949805